import { Component, OnInit } from '@angular/core';
import * as RecordRTC from 'recordrtc';
import * as WaveSurfer from 'wavesurfer.js';
import * as MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.js';
WaveSurfer.microphone = MicrophonePlugin;
import { Subscription } from 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { DomSanitizer } from '@angular/platform-browser'
import { RecordRtcService } from '@services/record-rtc.service';
@Component({
  selector: 'app-audiorecord',
  templateUrl: './audiorecord.component.html',
  styleUrls: ['./audiorecord.component.sass']
})
export class AudiorecordComponent implements OnInit {

  recordedTime=0;
  recorder;
  wsurfer;
  audioUrl;
  result;
  microphone;
  options:any;
  constructor(public _recordRTC:RecordRtcService,private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }
  start(){
    let THIS=this;
    navigator.mediaDevices.getUserMedia({ audio: true }).then(s => {

let isEdge = navigator.userAgent.indexOf('Edge') !== -1 && (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob);
let  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      this.options = {
        type: 'audio',
        numberOfAudioChannels: isEdge ? 1 : 2,
        checkForInactiveTracks: true,
        bufferSize: 16384
      };
      if(isSafari || isEdge) {
       // this.options['recorderType'] = RecordRTC.StereoAudioRecorder;
      //  console.log( RecordRTC.StereoAudioRecorder);
    }

    if(navigator.platform && navigator.platform.toString().toLowerCase().indexOf('win') === -1) {
      this.options['sampleRate'] = 48000; // or 44100 or remove this line for default
    }

    if(isSafari) {
      this.options['sampleRate'] = 44100;
      this.options['bufferSize'] = 4096;
      this.options['numberOfAudioChannels'] = 2;
    }
  /*    alert("issafari"+isSafari)
    if(isSafari || isEdge) {
    options['recorderType'] =  RecordRTC.StereoAudioRecorder;
  } */

      this.recorder = new RecordRTC.StereoAudioRecorder(s,this.options );
    // this.recorder = RecordRTC(s,this.options );

   /*   RecordRTC.captureMicrophone(function(mic) {
       console.log("inside",mic);
     }); */
      this.recorder.record();

      this.wsurfer = WaveSurfer.create({
        container: '#waveform',
        waveColor: '#57afa2',
        progressColor: '#57afa2',
        barHeight: 2,
        plugins: [
          MicrophonePlugin.create({
            bufferSize: 4096,
            numberOfInputChannels: 1,
            numberOfOutputChannels: 1,
            constraints: {
              video: false,
              audio: true
            }
          })
        ]
      });
      this.wsurfer.microphone.start();


      let timeshow = Observable.interval(1000).take(5).map(x => x + 1);
      timeshow.subscribe(i => {
        this.recordedTime = i;
        if (this.recordedTime == 5) {

          this.wsurfer.microphone.stop();
          $("#waveform").empty();

          this.recorder.stop((blob) => {
            
            // if (this.startTime) {
              THIS.result=blob;
               const mp3Name = encodeURIComponent('audio_' + new Date().getTime() + '.mp3');
               console.log(blob);
               THIS.audioUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
              /*  this.stopMedia();
               this._recorded.next({ blob: blob, title: mp3Name }); */
               //this._recorded.next({ blob: blob, title: mp3Name });
            // }
           }, () => {
            /*  this.stopMedia();
             this._recordingFailed.next(); */
           });
        }
      });


    }).catch(error => {
     
    });

  }
   start1(){
     let THIS=this;
    var isEdge = navigator.userAgent.indexOf('Edge') !== -1 && (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob);
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    navigator.mediaDevices.getUserMedia({
      audio: isEdge ? true : {
          echoCancellation: false
      }
  }).then(function(mic) {
    this.microphone = mic;
    this.options = {
      type: 'audio',
      numberOfAudioChannels: isEdge ? 1 : 2,
      checkForInactiveTracks: true,
      bufferSize: 16384
    };
    if(isSafari || isEdge) {
     // this.options['recorderType'] = RecordRTC.StereoAudioRecorder;
    //  console.log( RecordRTC.StereoAudioRecorder);
  }

  if(navigator.platform && navigator.platform.toString().toLowerCase().indexOf('win') === -1) {
    this.options['sampleRate'] = 48000; // or 44100 or remove this line for default
  }

  if(isSafari) {
    this.options['sampleRate'] = 44100;
    this.options['bufferSize'] = 4096;
    this.options['numberOfAudioChannels'] = 2;
  }
    this.recorder = RecordRTC(this.microphone, this.options);

    this.recorder.startRecording();
    let timeshow = Observable.interval(1000).take(5).map(x => x + 1);
    timeshow.subscribe(i => {
      this.recordedTime = i;
      if (this.recordedTime == 5) {

        this.wsurfer.microphone.stop();
        $("#waveform").empty();

        this.recorder.stop((blob) => {
          
          // if (this.startTime) {
            THIS.result=blob;
             const mp3Name = encodeURIComponent('audio_' + new Date().getTime() + '.mp3');
             console.log(blob);
             THIS.audioUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
            /*  this.stopMedia();
             this._recorded.next({ blob: blob, title: mp3Name }); */
             //this._recorded.next({ blob: blob, title: mp3Name });
          // }
         }, () => {
          /*  this.stopMedia();
           this._recordingFailed.next(); */
         });
      }
    });


  }).catch(function(error) {
      alert('Unable to capture your microphone. Please check console logs.');
      console.error(error);
  });

  }
  startVoiceRecord(){
    alert("click");
    this._recordRTC.toggleRecord();
  }
  newreco(){

    if (navigator.mediaDevices) {
      alert ("Media device supported");
  }
  else {
      alert ("Media device not supported");
  }
    this.options = {
      type: 'audio',
      checkForInactiveTracks: true,
      bufferSize: 16384
    };

    navigator.mediaDevices.getUserMedia({
      video: false,
      audio: true
  }).then(async function(stream) {
      let recorder = RecordRTC(stream, {
          type: 'audio'
      });
      recorder.startRecording();
  
      const sleep = m => new Promise(r => setTimeout(r, m));
      await sleep(3000);
  
      recorder.stopRecording(function() {
          let blob = recorder.getBlob();
         // invokeSaveAsDialog(blob);
      });
  }).catch(function (err){
alert("error"+err);
  });
  }
}
